<page-title text="IP address Verification | BitOasis" i18n-text="@@pageTitle.verifyIpAddress"></page-title>
<site-layout class="narrow push">
  <h2 class="text-header text-bold text-center mb-2" i18n="@@front.verifyIp.title">IP Address Verification</h2>
  <div class="p-3"></div>
  
  <auth-verify-ip-address></auth-verify-ip-address>
</site-layout>